import { TODO, UIBModalService } from '@b2b/types/core';
import angular, { IScope } from 'angular';

TemplatesCreateDescriptionController.$inject = ['$scope', '$uibModal', 'ValidateService', 'TemplatesService'];

function TemplatesCreateDescriptionController(
  $scope: IScope & { templatesCreateDescription: TODO },
  $uibModal: UIBModalService,
  ValidateService: TODO,
  TemplatesService: TODO
) {
  const ctrl = {
    model: {} as TODO,
    selectedPrimaryPhoto: '',
    shortDescriptionMax: 300,
    shortDescriptionRemaining: 300,

    uploadError: '',

    customFields: [] as TODO[],

    summernoteConfig: {
      height: 300,
      shortcuts: false,
      toolbar: [
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height']],
      ],
    },

    isSubmitted: false,

    validators: [] as TODO[],

    templatesService: TemplatesService,

    init: function () {
      ctrl.model = TemplatesService.getModel();

      ctrl.initValidators();

      ValidateService.addFieldTests(ctrl.validators);

      ctrl.initPrimaryPhoto();
      $scope.$on('TemplatesService::Update', ctrl.onTemplatesServiceUpdate);
      $scope.$on('TemplatesCreateController::Save', ctrl.onTemplatesCreateControllerSave);
      $scope.$on('upload::selectionChange', ctrl.onUploadSelectionChange);
      $scope.$on('upload::queueUpdated', ctrl.onUploadQueueUpdated);
      $scope.$on('upload::remove', ctrl.onUploadRemove);
      $scope.$on('upload::done', ctrl.onUploadDone);
      $scope.$on('upload::add', ctrl.onUploadAdd);
      $scope.$on('upload::error', ctrl.onUploadError);

      ctrl.templatesService.setIsTabLoading(false, 'details');
    },

    initValidators: function () {
      ctrl.validators = [
        {
          field: 'templates-create-description-short',
          greater: {
            message:
              'Your description must be ' +
              $scope.templatesCreateDescription.shortDescriptionMax +
              ' characters or fewer',
            test: function () {
              return {
                less: $scope.templatesCreateDescription.model.shortDescription
                  ? $scope.templatesCreateDescription.model.shortDescription.length
                  : 0,
                greater: $scope.templatesCreateDescription.shortDescriptionMax,
                equalTo: true,
              };
            },
          },
        },
        {
          field: 'templates-create-description-long',
          len: {
            message: 'Your description must not be empty',
            test: function () {
              return {
                value: $scope.templatesCreateDescription.model.description,
              };
            },
          },
        },
        {
          field: 'templates-create-description-email-notify',
          equal: {
            message: 'Please enter valid email addresses',
            test: function () {
              let ii = 0;
              let validCount = 0;

              if (ctrl.model.emailNotify) {
                ii = ctrl.model.emailNotify.length;

                for (let i = 0; i < ii; i++) {
                  if (ValidateService.validators.email(ctrl.model.emailNotify[i].email)) {
                    validCount++;
                  }
                }
              }

              return [ii, validCount];
            },
          },
        },
        {
          field: 'templates-create-description-online-payment-email-notify',
          equal: {
            message: 'Please enter valid email addresses',
            test: function () {
              let ii = 0;
              let validCount = 0;

              if (ctrl.model.onlinePaymentsForOrgOrdersEmailNotify) {
                ii = ctrl.model.onlinePaymentsForOrgOrdersEmailNotify.length;

                for (let i = 0; i < ii; i++) {
                  if (ValidateService.validators.email(ctrl.model.onlinePaymentsForOrgOrdersEmailNotify[i].email)) {
                    validCount++;
                  }
                }
              }

              return [ii, validCount];
            },
          },
        },
      ];
    },
    initPrimaryPhoto: function () {
      if (Array.isArray(ctrl.model.images)) {
        for (let i = 0, ii = ctrl.model.images.length; i < ii; i++) {
          if (ctrl.model.images[i].primary) {
            ctrl.selectedPrimaryPhoto = ctrl.model.images[i].id;
          }
        }
      }
    },
    isValid: function (field) {
      if (ctrl.isSubmitted) {
        return ValidateService.check(ctrl.validators, field);
      }

      return true;
    },

    getError: function (field) {
      return ValidateService.getError(field);
    },

    isPrimaryPhoto: function (id) {
      return id === ctrl.selectedPrimaryPhoto;
    },

    updatePrimaryPhoto: function () {
      if (Array.isArray(ctrl.model.images)) {
        for (let i = 0, ii = ctrl.model.images.length; i < ii; i++) {
          ctrl.model.images[i].primary = ctrl.selectedPrimaryPhoto === ctrl.model.images[i].id;
        }
      }
    },

    hasImages: function () {
      return TemplatesService.hasImages();
    },

    removePhoto: function (id) {
      if (Array.isArray(ctrl.model.images)) {
        for (let i = 0, ii = ctrl.model.images.length; i < ii; i++) {
          if (ctrl.model.images[i].id === id) {
            if (i === ii - 1) {
              ctrl.model.images[0].primary = true;
              ctrl.selectedPrimaryPhoto = ctrl.model.images[0].id;
            } else if (
              i === 0 &&
              ctrl.model.images[i].id === ctrl.selectedPrimaryPhoto &&
              ctrl.model.images.length > 1
            ) {
              ctrl.model.images[1].primary = true;
              ctrl.selectedPrimaryPhoto = ctrl.model.images[1].id;
            }
            ctrl.model.images.splice(i, 1);
            break;
          }
        }
      }
    },

    checkShortDescription: function () {
      if (ctrl.model.shortDescription) {
        console.log('ProgramsCreateController::checkShortDescription', ctrl.model.shortDescription.length);
        if (ctrl.model.shortDescription.length > ctrl.shortDescriptionMax) {
          ctrl.model.shortDescription = ctrl.model.shortDescription.substr(0, ctrl.shortDescriptionMax);
        }
      } else {
        ctrl.model.shortDescription = '';
      }
      ctrl.shortDescriptionRemaining = ctrl.shortDescriptionMax - ctrl.model.shortDescription.length;
    },

    checkThirdPartyAmount: function () {
      const percent = parseFloat(ctrl.model.thirdPartyPercentage);

      if (!isNaN(percent)) {
        ctrl.model.thirdPartyPercentage = percent;
      } else {
        ctrl.model.thirdPartyPercentage = '0';
      }
    },

    checkForWhiteSpaces: function () {
      ctrl.model.shortDescription = ctrl.model.shortDescription.replace(/[\s\n]/g, ' ');
    },

    isValidEmailNotify: function (recipient) {
      return ValidateService.validators.email(recipient.email);
    },

    removeEmailNotifyRecipient: function (index) {
      if (Array.isArray(ctrl.model.emailNotify) && ctrl.model.emailNotify[index]) {
        ctrl.model.emailNotify.splice(index, 1);
      }
    },

    addEmailNotifyRecipient: function () {
      if (!Array.isArray(ctrl.model.emailNotify)) {
        ctrl.model.emailNotify = [];
      }
      ctrl.model.emailNotify.push({
        name: '',
        email: '',
      });
    },

    removeOnlinePaymentsForOrgOrdersEmailNotifyRecipient: function (index) {
      if (
        Array.isArray(ctrl.model.onlinePaymentsForOrgOrdersEmailNotify) &&
        ctrl.model.onlinePaymentsForOrgOrdersEmailNotify[index]
      ) {
        ctrl.model.onlinePaymentsForOrgOrdersEmailNotify.splice(index, 1);
      }
    },

    addOnlinePaymentsForOrgOrdersEmailNotifyRecipient: function () {
      if (!Array.isArray(ctrl.model.onlinePaymentsForOrgOrdersEmailNotify)) {
        ctrl.model.onlinePaymentsForOrgOrdersEmailNotify = [];
      }
      ctrl.model.onlinePaymentsForOrgOrdersEmailNotify.push({
        name: '',
        email: '',
      });
    },

    verifyCustomFields: function () {
      // Splice out custom fields with no values to prevent errors
      if (Array.isArray(ctrl.model.customFields)) {
        for (let i = ctrl.model.customFields.length - 1, ii = 0; i >= ii; i--) {
          if (
            ctrl.model.customFields[i].name.replace(/s+/g).length > 0 &&
            ctrl.model.customFields[i].value.replace(/s+/g).length > 0
          ) {
            // Valid do nothing
          } else {
            // Splice out the fields
            ctrl.model.customFields.splice(i, 1);
          }
        }
      }
    },

    processCustomFields: function () {
      return $scope.templatesCreateDescription.customFields.filter(function (item) {
        return item.value;
      });
    },

    success: {
      init: function (response) {},
    },

    error: {
      init: function (response) {},
    },

    onTemplatesCreateControllerSave: function (e, data) {
      ctrl.updatePrimaryPhoto();

      ctrl.model.customFields = ctrl.processCustomFields();

      TemplatesService.setModel(ctrl.model);

      ctrl.isSubmitted = true;
      ValidateService.validate(ctrl.validators);
    },

    onUploadRemove: function (e, data) {
      ctrl.uploadError = '';

      for (let i = 0, ii = ctrl.model.images.length; i < ii; i++) {
        if (data.file.id === ctrl.model.images[i].id) {
          ctrl.model.images.splice(i, 1);
        }
      }

      console.log('TemplatesCreateDescriptionController::onUploadRemove', ctrl.model.images);
    },

    onUploadAdd: function (e, data) {
      $scope.templatesCreateDescription.uploadError = '';
      console.log('TemplatesCreateDescriptionController::onUploadAdd', data);
    },

    onUploadError: function (e, data) {
      console.log('TemplatesCreateDescriptionController::onUploadError', data);
      $scope.templatesCreateDescription.uploadError = data.result.error || 'There was an error uploading the file.';
    },

    onUploadDone: function (e, data) {
      ctrl.uploadError = '';
      console.log('TemplatesCreateDescriptionController::onUploadDone', data);

      if (!Array.isArray(ctrl.model.images)) {
        ctrl.model.images = [];
      }

      ctrl.model.images.push({
        id: data.file.uuid,
        preview: data.file.previewPath,
        screen: data.file.screenPath,
        primary: false,
      });

      if (ctrl.model.images.length === 1) {
        ctrl.model.images[0].primary = true;
        ctrl.selectedPrimaryPhoto = ctrl.model.images[0].id;
      }

      console.log('TemplatesCreateDescriptionController::onUploadDone', ctrl.model.images);

      $scope.$apply();
    },

    onUploadSelectionChange: function (e, data) {
      if (!Array.isArray(ctrl.model.images)) {
        ctrl.model.images = [];
      }

      for (let i = 0, ii = ctrl.model.images.length; i < ii; i++) {
        if (data.file) {
          ctrl.model.images[i].primary = data.file.id === ctrl.model.images[i].id;
        }
      }
      console.log('TemplatesCreateDescriptionController::onUploadSelectionChange', data, ctrl.model.images);
    },

    onUploadQueueUpdated: function (e, data) {
      console.log('TemplatesCreateDescriptionController::onUploadQueueUpdated', data);
    },

    editCaption: function (image: { description: string }) {
      $uibModal
        .open<string | undefined>({
          templateUrl: 'views/application/views/templates/create/modals/caption.tpl.html',
          size: 'lg',
          controller: 'EditImageCaptionModalController',
          resolve: {
            captionText: () => image.description,
          },
        })
        .result.then((captionText) => {
          if (typeof captionText !== 'undefined') {
            image.description = captionText;
          }
        });
    },

    onTemplatesServiceUpdate: function (e, data) {
      ctrl.model = TemplatesService.getModel();
      ctrl.initPrimaryPhoto();
    },
  };

  $scope.templatesCreateDescription = ctrl;
  ctrl.init();
}

export const TemplatesCreateDescriptionControllerModule = angular
  .module('acme.view.application.templates.create.description.controllers', [
    'acme.common.service.templates',
    'acme.common.service.validate',
    'acme.view.application.templates.create.modals.captionEditModal.controllers',
  ])
  .controller('TemplatesCreateDescriptionController', TemplatesCreateDescriptionController).name;
